import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AnswersConfig } from '@core/models/built/procedure-step-config.model';
import { InputJson } from '@core/models/built/session-step-value-json.model';
import { SessionStepValueType } from '@core/models/built/session-step-value-type.enum';
import { SessionStep, SessionStepValue } from '@core/models/session.model';
import { filterTruthy } from '@utils';
import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './input-single-choice-session.component.html',
  styles: [`
    .mat-list-text {
      text-align: center;
      padding-right: 0;
    }
    .mat-list-item {
      color: var(--secondary);
      background-color: var(--secondaryContrast);
      border: 1px solid var(--secondary);
    }
    .mat-list-single-selected-option {
      color: var(--secondaryContrast);
      background-color: var(--secondary);
    }
  `]
})
export class InputSingleChoiceSessionComponent implements OnChanges {

  @Input() step!: SessionStep;

  @Output() commitAndNext = new EventEmitter<SessionStep>();

  inputForm: FormGroup = this.fb.group({
    value: [undefined, [Validators.required]]
  });

  private step$$ = new BehaviorSubject<SessionStep | undefined>(undefined);
  answers$ = this.step$$.pipe(
    filterTruthy(),
    map(step => (step.procedureStep?.config as AnswersConfig).answers)
  );

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

  submit() {
    if (!this.inputForm.invalid) {
      const answer = this.inputForm.value.value[0];
      const now = DateTime.local().toJSDate();
      const value: SessionStepValue = {
        workflowId: this.step.workflowId,
        workflowStepId: this.step.workflowStepId,
        sessionId: this.step.sessionId,
        timestamp: now,
        type: SessionStepValueType.inputChoice,
        value: { input: answer } as InputJson
      };
      this.commitAndNext.emit({ ...this.step, completedOn: now, values: [value] });
    }
  }

}
